import React from "react";

export function SectionCard({
  title,
  subtitle,
  children,
}: {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
}) {
  return (
    <section className="min-w-0 rounded-2xl border border-indigo-200 bg-white p-4 shadow-sm sm:p-6">
      <div className="mb-5">
        <h2 className="break-words text-xl font-semibold text-black sm:text-2xl">{title}</h2>
        {subtitle ? <p className="mt-1 text-sm text-black">{subtitle}</p> : null}
      </div>
      <div className="space-y-4">{children}</div>
    </section>
  );
}
